import * as React from 'react';
import { History } from 'history';
import { MainContent, Container, Notice, Separator } from 'telia-front-react';
import ErrorUtil from '../util/ErrorUtil';
import { TranslationsContext } from '@teliaee/telia-translate';
interface ComponentErrorBoundaryProps {
  messageKey?: string;
  history: History;
  children?: React.ReactNode;
}

class ComponentErrorBoundary extends React.Component<ComponentErrorBoundaryProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public state = {
    hasError: false,
    otelReference: ''
  };

  constructor(props: ComponentErrorBoundaryProps) {
    super(props);

    props.history.listen(() => {
      if (this.state.hasError) {
        this.setState({
          hasError: false,
          otelReference: ''
        });
      }
    });
  }

  public componentDidCatch(error: Error | null) {
    const otelReference = ErrorUtil.pushError(false, error);
    this.setState({ hasError: true, otelReference });
  }

  public render() {
    const translate = this.context.translate;
    const { messageKey = 'general.error.message' } = this.props;
    if (this.state.hasError) {
      return (
        <MainContent>
          <Container>
            <Separator spacing="large" color="invisible" />
            <div role="alert">
              <Notice type="error">
                {translate(messageKey)}: {this.state.otelReference}
              </Notice>
            </div>
            <Separator spacing="large" color="invisible" />
          </Container>
        </MainContent>
      );
    }
    return this.props.children;
  }
}

export default ComponentErrorBoundary;
